// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"_-src-components-NewUserSegment-components-SetupStep-index---stepTitle---AUi2X","stepBody":"_-src-components-NewUserSegment-components-SetupStep-index---stepBody---13B9e","formItem":"_-src-components-NewUserSegment-components-SetupStep-index---formItem---1JzGQ","userTypePlaceholder":"_-src-components-NewUserSegment-components-SetupStep-index---userTypePlaceholder---25Fv-","userTypeSelect":"_-src-components-NewUserSegment-components-SetupStep-index---userTypeSelect---1k-Ij"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewUserSegment/components/SetupStep/index.css
// module id = 825
// module chunks = 1